var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OpusSelect',{staticClass:"my-4 w-full lg:max-w-[200px]",attrs:{"name":"sort-select","label":_vm.$t('catalog.sortby'),"options":_vm.options},on:{"change":_vm.updateSort}})}
var staticRenderFns = []

export { render, staticRenderFns }